import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { Marketplace } from "@front/m19-api-client";
import { Marketplaces } from "@front/m19-models";
import { MarketplaceNamePipe } from "@front/m19-services";
import { MarketplaceFlagComponent } from "@front/m19-ui";

@Component({
  selector: "app-marketplace-formatter",
  imports: [MarketplaceFlagComponent, MarketplaceNamePipe],
  template: `
    <div class="flex items-center gap-2">
      @if (values().length > 0) {
        <IMarketplaceFlag [marketplace]="values()[0]" />
        {{ values()[0] | marketplaceNamePipe }}
      }
      @if (values().length > 1) {
        <span class="text-gray-400">{{ label() }}</span>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarketplaceFormatterComponent {
  readonly values = input.required<Marketplace[]>();

  readonly Marketplaces = Marketplaces;

  readonly label = computed(() => {
    return this.values().length > 1 ? `(+${this.values().length - 1})` : "";
  });
}
